class StickyHeader extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.header = document.querySelector(".section-header");
    this.headerIsAlwaysSticky = this.getAttribute("data-sticky-type") === "always";
    this.headerBounds = {};

    this.setHeaderHeight();

    this.throttleResize = throttle(() => this.setHeaderHeight(), 500);
    window.addEventListener("resize", this.throttleResize.bind(this));

    // Apply sticky positioning from the start for smooth scrolling
    if (this.headerIsAlwaysSticky) {
      this.header.classList.add("shopify-section-header-sticky");
    } else if (this.getAttribute("data-sticky-type") !== "none") {
      // For hide-on-scroll type, also apply sticky from the start
      this.header.classList.add("shopify-section-header-sticky");
    }

    this.currentScrollTop = 0;
    this.preventReveal = false;
    this.predictiveSearch = this.querySelector("predictive-search");
    this.searchBarVisible = true; // Track search bar visibility state

    this.onScrollHandler = this.onScroll.bind(this);
    this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

    this.addEventListener("preventHeaderReveal", this.hideHeaderOnScrollUp);
    window.addEventListener("scroll", this.onScrollHandler, false);

    this.createObserver();
  }

  setHeaderHeight() {
    let isMobileMQ = window.matchMedia("(max-width: 990px)");
    let transparentHeader = this.querySelector(".header--homepage-transparent");
    let headerHeight = this.header.offsetHeight;
    if (transparentHeader) {
      headerHeight = transparentHeader.offsetHeight + 1;
    }

    if (isMobileMQ.matches) {
      let padding = 40;
      let searchBar = this.querySelector(".search-non-modal");
      let searchBarHeight = searchBar.getBoundingClientRect().height;
      // headerHeight -= searchBarHeight + padding;
    }
    document.documentElement.style.setProperty("--header-height", `${headerHeight}px`);
  }

  disconnectedCallback() {
    this.removeEventListener("preventHeaderReveal", this.hideHeaderOnScrollUp);
    window.removeEventListener("scroll", this.onScrollHandler);
  }

  createObserver() {
    let observer = new IntersectionObserver((entries, observer) => {
      this.headerBounds = entries[0].intersectionRect;
      observer.disconnect();
    });

    let transparentHeader = this.querySelector(".header--homepage-transparent");
    if (transparentHeader) {
      observer.observe(transparentHeader);
    } else {
      observer.observe(this.header);
    }
  }

  onScroll() {
    let searchBar = document.querySelector(".search-non-modal");

    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

    //750 down
    let windowWidth = window.innerWidth;

    if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

    //scrolling down
    if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
      this.header.classList.add("scrolled-past-header");

      //mobile - hide search bar only if it's currently visible
      if (windowWidth < 1050 && this.searchBarVisible) {
        searchBar.setAttribute("data-hidden", "true");
        this.searchBarVisible = false;
      }

      if (this.preventHide) return;
      requestAnimationFrame(this.hide.bind(this));

      // Update add-to-cart-bar position when scrolling down
      this.updateAddToCartBarPosition();

      //scrolling up
    } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
      this.header.classList.add("scrolled-past-header");

      //mobile - show search bar only if it's currently hidden
      if (windowWidth < 750 && !this.searchBarVisible) {
        searchBar.setAttribute("data-hidden", "false");
        this.searchBarVisible = true;
      }

      if (!this.preventReveal) {
        requestAnimationFrame(this.reveal.bind(this));
      } else {
        window.clearTimeout(this.isScrolling);

        this.isScrolling = setTimeout(() => {
          this.preventReveal = false;
        }, 66);

        requestAnimationFrame(this.hide.bind(this));
      }

      // Update add-to-cart-bar position when scrolling up
      this.updateAddToCartBarPosition();
    } else if (scrollTop <= this.headerBounds.top) {
      this.header.classList.remove("scrolled-past-header");
      // Reset search bar visibility when at top
      if (!this.searchBarVisible) {
        searchBar.setAttribute("data-hidden", "false");
        this.searchBarVisible = true;
      }
      requestAnimationFrame(this.reset.bind(this));
    }

    this.currentScrollTop = scrollTop;
  }

  hide() {
    if (this.headerIsAlwaysSticky) return;
    this.header.classList.add("shopify-section-header-hidden", "shopify-section-header-sticky");
    this.closeMenuDisclosure();
    this.closeSearchModal();
    this.updateAddToCartBarPosition();
  }

  reveal() {
    if (this.headerIsAlwaysSticky) return;
    this.header.classList.add("shopify-section-header-sticky", "animate");
    this.header.classList.remove("shopify-section-header-hidden");
    this.updateAddToCartBarPosition();
  }

  reset() {
    if (this.headerIsAlwaysSticky) return;
    this.header.classList.remove(
      "shopify-section-header-hidden",
      "shopify-section-header-sticky",
      "animate",
    );
    this.updateAddToCartBarPosition();
  }

  updateAddToCartBarPosition() {
    const addToCartBar = document.querySelector(".add-to-cart-bar");
    if (!addToCartBar) return;

    // Get the header's bottom position using getBoundingClientRect
    // This accounts for all header states: visible, hidden, sticky, etc.
    const headerRect = this.header.getBoundingClientRect();
    const headerBottom = Math.max(0, headerRect.bottom);

    // Set the add-to-cart bar position to sit directly below the header
    addToCartBar.style.top = `${headerBottom}px`;
  }

  closeMenuDisclosure() {
    this.disclosures = this.disclosures || this.header.querySelectorAll("header-menu");
    this.disclosures.forEach((disclosure) => disclosure.close());
  }

  closeSearchModal() {
    this.searchModal = this.searchModal || this.header.querySelector("details-modal");
    if (this.searchModal) {
      this.searchModal.close(false);
    }
  }
}

customElements.define("sticky-header", StickyHeader);
